import { CurrentUser, Role } from "./contexts/authContext";
import { Beacon } from "./screens/beacons/Beacon";
import { Beacons } from "./screens/beacons/Beacons";
import { ConstructionProject } from "./screens/construction-project/ConstructionProject";
import { DataConsumerIntegration } from "./screens/integration-platform/DataConsumerIntegration";
import { DataConsumerIntegrations } from "./screens/integration-platform/DataConsumerIntegrations";
import { NoRole } from "./screens/no-role/NoRole";
import { Organization } from "./screens/organization/Organization";
import { Organiztations } from "./screens/organizations/Organizations";
import { SCBOneDevice } from "./screens/scb-one/SCBOneDevice";
import { SCBOneDevices } from "./screens/scb-one/SCBOneDevices";
import { Users } from "./screens/users/Users";

interface Route {
  path: string;
  component: () => JSX.Element;
  navigationMenu?: { labelKey: string };
  roles?: Role[];
  disallowRoles?: Role[];
}

const allRoutes: Route[] = [
  {
    path: "/construction-projects",
    component: ConstructionProject,
    navigationMenu: {
      labelKey: "construction-projects",
    },
    roles: ["road-safety-manager", "solution-operator"],
  },
  {
    path: "/beacons",
    component: Beacons,
    navigationMenu: {
      labelKey: "beacons",
    },
    roles: ["solution-operator", "road-safety-manager"],
  },
  {
    path: "/beacons/:beaconId",
    component: Beacon,
    roles: ["solution-operator", "road-safety-manager"],
  },
  {
    path: "/scb-one",
    component: SCBOneDevices,
    navigationMenu: {
      labelKey: "scb-one",
    },
    roles: ["solution-operator", "scb-one-data-analyst"],
  },
  {
    path: "/scb-one/:deviceSerial",
    component: SCBOneDevice,
    roles: ["solution-operator", "scb-one-data-analyst"],
  },
  {
    path: "/organizations",
    component: Organiztations,
    navigationMenu: {
      labelKey: "organizations",
    },
    roles: ["solution-operator", "road-safety-manager", "scb-one-data-analyst"],
  },
  {
    path: "/organizations/:organizationId",
    component: Organization,
    roles: ["solution-operator", "road-safety-manager", "scb-one-data-analyst"],
  },
  {
    path: "/integrations",
    component: DataConsumerIntegrations,
    navigationMenu: {
      labelKey: "integrations",
    },
    roles: ["integration-platform-user", "solution-operator"],
  },
  {
    path: "/integrations/:consumerId",
    component: DataConsumerIntegration,
    roles: ["integration-platform-user", "solution-operator"],
  },
  {
    path: "/users",
    component: Users,
    navigationMenu: {
      labelKey: "users",
    },
    roles: ["solution-operator", "integration-platform-user"],
    disallowRoles: ["road-safety-manager"],
  },
];

export function routes(user: CurrentUser): Route[] {
  if (user.accessToken.payload["cognito:groups"].length === 0) {
    return [
      {
        path: "/",
        component: NoRole,
      },
    ];
  }

  return allRoutes.filter((route) => {
    // Check if user has required roles
    const hasRequiredRole = !route.roles?.length ||
      route.roles.some(
        (role) => user.accessToken.payload["cognito:groups"].indexOf(role) >= 0
      );

    // Check if user has any disallowed roles
    const hasDisallowedRole = route.disallowRoles?.some(
      (role) => user.accessToken.payload["cognito:groups"].indexOf(role) >= 0
    ) || false;

    // Include route if user has required role AND doesn't have disallowed role
    return hasRequiredRole && !hasDisallowedRole;
  });
}
